import { A, Div, H2, H3, H4, OL, LI, P, VArray, Input, Span, Label, reactive, Checkbox, UL, Table, TR, TD, Section, TBody, THead, TH } from 'alkali'
import { get, post } from 'tools/request'
import { parameterToQuestion, liveParsed, buildingQuestion, importedCollections } from 'model/SearchQuery'
import { questionLabel, questionToURIComponent } from 'analysis/Question'
import { availableQuestions, getAvailableQuestions } from 'model/AvailableAnalyses'
import app from 'app/app'
import * as searchIcon from 'icons/search.svg'
import * as lockIcon from 'icons/lock-1.svg'
import * as checklistIcon from 'icons/checklist.svg'
import Icon from '../Icon'
import LoadingDots from '../generic/LoadingCircle';
import * as CloseIcon from 'icons/close.svg'
import { unfavoriteAnalysisSelections } from '../navbar/FavoriteControl'
import { CollectionLink, CollectionsGrouping, CollectionsListing, friendlyCollectionName } from 'components/filter/ImportCollections'

export let questionsSource = new VArray().to(() => Promise.resolve(app.user).then(user =>
	user ? get('/portal/AnalysisByUserDate?user=' + user.Id) : {}))

export const optionFilter = (event) => {
	let text = event.target.value;
	const items = document.querySelector('.questions-list')?.getElementsByClassName('filter-option');
	if(text && items){
		const searchMatch = new RegExp(text, 'i');
		if (items) {
			for (let i = 0; i < items.length; i++) {
				let item = items[i];
				let selectedCheck = item.classList.contains('selected')
				if (searchMatch.test(item.textContent) && !selectedCheck) {
					item.classList.remove('filtered')
				} else if (!selectedCheck) {
					item.classList.add('filtered')
				}
			}
		}
	} else if(items) {
		for (let i = 0; i < items.length; i++) {
				items[i].classList.remove('filtered')
		}
	}
}
const addDraggingClass = (event) => {
	const optionTarget = event.target
	optionTarget.classList.add('dragging')
}
const removeDraggingClass = (event) => {
	const optionTarget = event.target
	optionTarget.classList.remove('dragging')
	const currentOption = optionTarget.classList.contains('current-option')
	if (currentOption) {
		optionTarget.setAttribute('pointer-events', 'auto')
	}
}

export const whileLoading = (questions) =>
	questions.whileResolving ? questions.whileResolving(LoadingDots) : questions

const exampleQuestions = [
	'Does_(intervention:Salmeterol)%2C_(intervention:Fluticasone_Propionate)%2C_(intervention:Indacaterol)%2C_(intervention:Tiotropium)%2C_(intervention:Formoterol)_or_(intervention:Glycopyrrolate)_%28vs_control%29_affect_(outcome:Trough_FEV1)_for_patients_with_(condition:COPD)%3F#network',

	'Does_(intervention:Alirocumab)%2C_(intervention:Evolocumab)%2C_(intervention:Ezetimibe)_or_(intervention:Statins)_%28vs_control%29_affect_(outcome:LDL_Cholesterol)_for_patients_with_(condition:Hypercholesterolemia)%3F#network',

	'Does_(intervention:Ustekinumab)%2C_(intervention:Adalimumab)%2C_(intervention:Secukinumab)_or_(intervention:Risankizumab)_%28vs_control%29_affect_(outcome:PASI_75)_for_patients_with_(condition:Plaque_Psoriasis)%3F#network',

	'Does_(intervention:Remdesivir)_%28vs_control%29_affect_(outcome:Mortality)_for_patients_with_(condition:COVID-19)?#network',

	'Does_(intervention:Humira)_%28vs_control%29_affect_(outcome:Clinical_Remission)_for_patients_with_(condition:Crohn\'s_Disease)%3F#network',

	'Does_(intervention:Tiotropium)_%28vs_control%29_affect_(outcome:Trough_FEV1)_for_patients_with_(condition:COPD)%3F#network',

	'How_does_(intervention:Atorvastatin)_%28vs_control%29_affect_(outcome:Stroke)%3F#network',

	'How_does_(intervention:Dupilumab)_%28vs_control%29_affect_(outcome:SGIEt:Eczema Area and Severity Index ❨EASI❩-75)%3F#network',

	'How_does_(intervention:Nifedipine)_or_(intervention:Enalapril)_affect_(outcome:Systolic_Blood_Pressure)%3F#direct',

	'How_does_(intervention:Rivaroxaban)_or_(intervention:Enoxaparin)_affect_(outcome:Deep_Vein_Thrombosis)%3F#direct',

	'Does_(intervention:Apixaban)%2C_(intervention:Dabigatran)%2C_(intervention:Rivaroxaban)%2C_(intervention:Edoxaban)%2C_(intervention:Aspirin)%2C_(intervention:Watchman)_or_(intervention:Warfarin)_reduce_(outcome:Mortality)_for_patients_with_Atrial_fibrillation%3F&selections=JyeWPArMb#frequentist&view=sources',

	'How_does_(intervention:Ferric_carboxymaltose)_%E2%9D%A8vs_control%E2%9D%A9_affect_(outcome:Heart_failure_Hospitalization)%3F&selections=tRXlkecYA#direct',

	'How_does_(intervention:Ferric_carboxymaltose)_%E2%9D%A8vs_control%E2%9D%A9_affect_Cardiovascular_Death%3F&selections=wpPOPXFEA#direct',

	'How_do_(intervention:SUBWT,S2BWM,S1BWM,SUCix4,SUER8o:Biologics)_%E2%9D%A8vs_control%E2%9D%A9_affect_Surgery_for_patients_with_Crohn%27s_disease%3F&selections=CjFtVjDgA&query=f(Effects%20of%20adalimumab%20therapy%20on%20incidence%20of%20hospitalization%20and%20surgery%20in%20Crohn%27s%20disease).x(or).f(Infliximab%20maintenance%20treatment%20reduces%20hospitalizations~,%20surgeries~,%20and%20procedures%20in%20fistulizing%20Crohn%27s%20disease).x(or).f(Comparison%20of%20scheduled%20and%20episodic%20treatment%20strategies%20of%20infliximab%20in%20Crohn%27s%20disease)#direct#study=53229224&view=sources',

	'How_does_(intervention:Infliximab)_%E2%9D%A8vs_control%E2%9D%A9_affect_(outcome:ACR_20)_for_patients_with_Rheumatoid_arthritis%3F&selections=NeOEIhcjA&query=f(%20Comparative%20clinical%20efficacy%20and%20safety%20of%20the%20proposed%20biosimilar%20ABP%20710%20with%20infliximab%20reference%20product%20in%20patients%20with%20rheumatoid%20arthritis).x(or).f(A%20randomized%20controlled%20trial%20comparing%20PF-06438179/GP1111%20~(an%20infliximab%20biosimilar~)%20and%20infliximab%20reference%20product%20for%20treatment%20of%20moderate%20to%20severe%20active%20rheumatoid%20arthritis%20despite%20methotrexate%20therapy).x(or).f(~.%20Comparing%20biosimilar%20SB2%20with%20reference%20infliximab%20after%2054%20weeks%20of%20a%20double-blind%20trial).x(or).f(A%20phase%20III%20randomized%20study%20to%20evaluate%20the%20efficacy%20and%20safety%20of%20CT-P13%20compared%20with%20reference%20infliximab%20in%20patients%20with%20active%20rheumatoid%20arthritis).x(or).f(%20Evaluation%20of%20the%20pharmacokinetic%20equivalence%20and%2054-week)#frequentist&view=sources'
]

export const analysisLabel = (analysis) => {
	let questionText = questionLabel(analysis)
	if (analysis.name) {
		return questionText
	}
	let labelAddition = (questionText.length > 0) ? ` - ${questionText}` : ''
	let collection = analysis.studyFilter?.importCollection
	let dsQuery = analysis.dsQuery?.name
	if(collection){
		return collection + (dsQuery ? ` - ${dsQuery}` : '') + labelAddition
	} else if(dsQuery) {
		return dsQuery + labelAddition
	}
	return questionLabel(analysis)
}
const ScreeningTable = (screenings, properties) => {
	return Table('#screening-table', [
		THead('#screening-theader', [
			TR([
				TH('Name'),
				TH('.query-question', ['Query'])
			])
		]),
		TBody('#screening-tbody', [
			screenings.map((screening) => {
				return TR('.screening-row', [
					TD('.screening-cell', [A([screening.screeningName || screening.name || questionLabel(screening)]),]),
					TD('.screening-cell.query-question', [A(screening.name || analysisLabel(screening))]),
				], {
					onclick() {
						window.location.href = '?search=' + (screening.question && questionToURIComponent(screening.question)) +
							(screening.id ? ('&selections=' + screening.id) : '') + (screening.analysisType ? '#' + screening.analysisType : '')
						navigator.sendBeacon('/portal/track?event=open-from-' + properties.type)
					},
					title: screening.screeningDescription ? screening.screeningDescription.trim() : questionLabel(screening)
				})
			})
		])
	])
}
const analysisTypeObject = {
	'auto': 'Automatic Analysis',
	'bayesian': 'Bayesian NMA',
	'cohort': 'Cohort Analysis',
	'custom': 'Custom Analysis',
	'direct': 'Direct Meta Analysis',
	'evidence-table': 'Evidence Table Report',
	'frequentist': 'Frequentist NMA',
	'network': 'Automatic Analysis',
	'screening': 'Screening',
}

const stringIncludesAnalysis = (string, analysisValue) => {
	return analysisValue.includes(string)
}

const typeToLabel = (analysisValue) => {
	if(analysisValue in analysisTypeObject){
		return analysisTypeObject[analysisValue]
	} else if (analysisValue) { 
	let includesValue = Object.keys(analysisTypeObject).find((key) => stringIncludesAnalysis(key, analysisValue))
	return includesValue ? analysisTypeObject[includesValue] : '-'
	}
	return '-'
}
// For questiontable - should we iterate back - check EV-1591 commits
const QuestionsGrid = (questions, properties) => {
	return (questions.length > 0) ? Table('.query-table', [
		THead('.query-theader', [
			TR([
				TH('.query-question', ['Query']),
				TH('Analysis Type')
			])
		]),
		TBody('.query-tbody', [
			questions.map((question) => {
				return TR('.query-row', [
					TD('.query-cell.query-question', [
							A(question.name || analysisLabel(question)),
							Div('.query-actions', [
								properties.type != 'examples'
									? (question.locked === true || question.locked === undefined)
										? (Icon('.favorites-icon', {
											icon: lockIcon,
											title: 'This query is locked'
										}))
										: null
									: null,
								(properties.type == 'examples' && question.selectionsAvailable)
									? Icon('.available-selections-icon', {
										icon: checklistIcon,
										title: 'This query has studies pre-selected for analysis'
									})
									: null,
								(properties.type == 'favorites' || properties.type == 'recent') ? Icon('.delete-question', {
									icon: CloseIcon,
									onclick: (event) => {
										event.stopPropagation()
										let finished
										if (properties.type == 'favorites')
											finished = unfavoriteAnalysisSelections(question)
										else
											finished = deleteRecent(question)
										finished.catch(error => {
											alert(error.message)
										})
									}
								}) : null,
							])
						]),
					TD('.query-cell', [A(typeToLabel(question.analysisType))]),
				], {
					onclick() {
						event.preventDefault()
						window.location.href = '?search=' + (question.question && questionToURIComponent(question.question)) +
							(question.id ? ('&selections=' + question.id) : '') + (question.analysisType ? '#' + question.analysisType : '')
						navigator.sendBeacon('/portal/track?event=open-from-' + properties.type)
					}
				})
			})
		])
	]) : P('.helper-text', ['No available options'])
}
export const ShortcutQuestions = Div('.fade-in', {
	// To do: rather than calliung availableQuestions several times, maybe re-write to get once
	created(properties) {
		let questions
		let collections
		switch (properties.type) {
			case 'examples':
				questions = exampleQuestions.map((exampleQuestion) => {
					const urlParams = new URLSearchParams(exampleQuestion)
					let selectionsId = urlParams.get('selections')
					if (selectionsId && selectionsId.includes('#')) {
						selectionsId = selectionsId.split('#')[0]
					}
					return {
						question: exampleQuestion.includes('&selections=') 
							? parameterToQuestion(exampleQuestion.split('&selections=')[0])
							: parameterToQuestion(exampleQuestion.split('#')[0]),
						id: exampleQuestion.includes('&selections=')
							? selectionsId
							: 'example',
						selectionsAvailable: exampleQuestion.includes('&selections='),
						analysisType: exampleQuestion.split('#')[1],
					}
				})
				break;
			case 'collections':
				collections = importedCollections.to(importedCollections => importedCollections.length > 0 ? CollectionsGrouping(importedCollections) : null).as(VArray)
				break;
			default:
				questions = availableQuestions.property(properties.type).as(VArray)
				break;
			}
			if ((properties.type !== 'collections') && (properties.type !== 'screenings')) {
				if (!questions.to) questions = reactive(questions)
				properties.content = [
					whileLoading(
						questions.to(() => {
							return QuestionsGrid(questions, properties)
						})
					)
			]
		} else if (properties.type == 'screenings') {
			if (!questions.to) questions = reactive(questions)
				properties.content = [
					whileLoading(
						questions.to(() => {
							return questions.length > 0 ? ScreeningTable(questions, properties) : P('.helper-text', ['No screenings available'])
						})
					)
			]
		} else if (properties.type == 'collections') {
			if (!collections.to) collections = reactive(collections)
			properties.content = [
				collections.to((collections) => {
					return collections?.length > 0 ? CollectionsListing(collections, properties) : P('.helper-text', ['No collections available, please start rapid extracting or contact us for importing collections'])
				})
			]
		}
	}
})

/* NOTE: AvailableQuestions WAS used by both FAQ and DA 
- below is used just for FAQ now */
class FAQAvailableQuestions extends Div('.available-questions', {
	ondragstart: addDraggingClass,
	ondragend: removeDraggingClass
}) {
	created(properties) {
		let questions,
			timer = 0,
			timeout = 400
		questions = getAvailableQuestions(false).property(properties.type).as(VArray)
		const categoryQuestions = properties?.categoryQuestions?.categoryQuestions
		let selectionsChildren = []
		for(var i=0; i< categoryQuestions?.length; i++){
			selectionsChildren.push(categoryQuestions[i].id)
		}
		const categoryIds = new Set(categoryQuestions?.map(result => result.id))
			questions = questions
				.filter((question) => !categoryIds.has(question.id))
				.filter((question) => (question.selectedStudyCount > -1 ? question.selectedStudyCount : question.selectedStudies?.length) > 0)
		const whileLoading = (questions) =>
			questions.whileResolving ? questions.whileResolving(LoadingDots) : questions
			
		properties.content = [
			whileLoading(
				Div([
					H2('.drag-text', ['Drag and drop to add favorites or order results']),
					Div('.faq-favorites', [
						// Available questions
						Div('.list-container', [
							H3(['Your Favorites']),
							Div('.questions-filter', [
								Input({
									id: 'option-filter',
									type: 'search',
									placeholder: 'Search Favorites',
									onsearch: (event) => {
										optionFilter(event)},
									onkeyup: (event) => {
										window.clearTimeout(timer)
										timer = window.setTimeout(() => {
											optionFilter(event)
										}, timeout)
									},
								}),
								Icon('.faq-search-icon', { icon: searchIcon }),
							]),
							// Because of the input we put the list drag container below and update the height to look like the selected - height of input
							Div('.favorites-container.draggable-container.questions-list#favorites-list', [
								questions.to(questions => questions?.length > 0 ? 
								questions.map(analysis => analysis &&
									Div(`.question.filter-option.available-option.draggable-question#${analysis.id}`, [
										Label('.question-label', [
											P({
												content: questionLabel(analysis),
												draggable: false
											}, [ ...(analysis.name ? [Div('.label-name', analysis.name) ] : []),
												Div('.label-question', analysisLabel(analysis)) ]),
											// To be developed: update of count to represent analysis count and not selected studies as it is presently - may need to update property name but UI component can be used once updated
											Div('.count-box-container', [
												Div('.count-box', [analysis.selectedStudyCount || analysis.selectedStudies.length])
											]),
											analysis.tags ? Div('.analysis-tags', analysis.tags.map(tag =>
												Div('.analysis-tag', [ 
													Span('.tag-name.truncate', {content: tag, title: tag})
												]))) : null,
										]),
										// properties.type == 'favorites' ? Div('.delete-question', ['X'], {
										//	 onclick() {
										//		 unfavoriteAnalysisSelections(analysis)
										//	 }
										// }) : null,
									], { draggable: true, title: 'To add, drag this to the category results' })
								) : (
									Div('.background-text', [P('You don\'t have any favorites to select.'), P('Only favorites with selected studies can be used in the dashboard.')])
								))
							], {
								ondragenter: (event) => {
									const currentOption = event.target.classList.contains('current-option')
									// We add this here rather than ondrop so we can animate where it may drop as the user positions the dragged element
									return currentOption ? false : null
								},
								ondragover: (event) => {
									const selectedList = document.getElementById('favorites-list')
									const draggable = document.querySelector('.dragging')
									const currentOption = draggable.classList.contains('current-option')
									// We add this here rather than ondrop so we can animate where it may drop as the user positions the dragged element
									return currentOption ? false : properties.allowDrag(event, selectedList)
								},
								ondrop: (event) => {
									const currentOption = event.target.classList.contains('current-option')
									currentOption ? null : event.preventDefault();
								}
							}),
						]),
						Div('.list-container', [
							H3(['Category Results']),
							Div('.selected-container.draggable-container#selected-list', [
								(categoryQuestions?.length > 0) ? (categoryQuestions.map(analysis => analysis &&
									Div(`.question.current-option.draggable-question#${analysis.id}`, [
										Label('.question-label', [
											P({
												draggable: false
											}, [
												...(analysis.name ? [ Div('.label-name', analysis.name) ] : []),
												Div('.label-question', [ analysis.question ]),
											]),
											analysis.tags ? Div('.analysis-tags', analysis.tags.map(tag =>
												Div('.analysis-tag', [ 
													Span('.tag-name.truncate', {content: tag, title: tag})
												]))) : null,
											// To be developed: update of count to represent analysis count and not selected studies as it is presently - may need to update property name but UI component can be used once updated
											Div('.count-box-container', [
											//	 P('.question-type', ["Existing"]),
												Div('.count-box', [analysis.count])
											]),
										]),
									], { draggable: true, title: 'You can drag to change the order of current selections' })
								)) : (
									Div('.background-text', [P('There are no questions added for this category.'), P('Drag from favorites to add and sort category results')])
								)

							], {
								ondragover: (event) => {
									const selectedList = document.getElementById('selected-list')
									const currentOption = event.target.classList.contains('current-option')
									// We add this here rather than ondrop so we can animate where it may drop as the user positions the dragged element
									return currentOption ? false : properties.allowDragSelected(event, selectedList, selectionsChildren)
								},
								ondragleave: (event) => {
									const currentOption = event.target.classList.contains('current-option')
									if (currentOption) {
										return false
									}
								}
							}),
						])
					])
				])
			)
		]
	}
}

export default FAQAvailableQuestions.defineElement('available-questions')

export async function deleteRecent(analysis) {
	if (confirm('Are you sure you want to remove this analysis from your recents "' + questionLabel(analysis || []) + '"?')) {
		await post('/portal/AnalysisSelections/' + analysis.id, {
			data: {
				method: 'deleteRecent',
				dashboard: !!window.isFAQDashboard,
			}
		})
		availableQuestions.updated()
		return true
	}
}
